import {fetchBasicJsonPostJson} from '@/script/common'

export default {
    getData: (page, itemsPerPage, filter, signal) => {
        var parameters = {
            page: page,
            pageSize: itemsPerPage
        };
        return fetchBasicJsonPostJson(
            '/Region/GetDataTableData',
            { data: Object.assign(filter, parameters), signal: signal },
            { useBlock: !signal }
        );
    }
};
